import { getDoc, doc } from 'firebase/firestore';
import { firestore } from '~/firebase/init';

import { Item, UniqItem } from '~/types/store/item';

export default async function getItems(
  itemsId: Array<{ storeId: string; id: string }>,
): Promise<Array<UniqItem>> {
  const res = await Promise.all(
    itemsId.map(({ storeId, id }) => {
      const ref = doc(firestore, 'stores', storeId, 'items', id);
      return getDoc(ref);
    }),
  );
  return res
    .filter((doc) => doc.exists() && !!doc.ref.parent.parent?.id)
    .map((doc) => ({
      id: doc.id,
      uniqId: `${doc.ref.parent.parent?.id || ''}${doc.id}`,
      storeId: doc.ref.parent.parent?.id || '',
      ...(doc.data() as Item),
    }));
}
